/** Constantes globales raids Gigamax — source unique client / serveur. */

export const GMAX_PARTICLE_CAP = 120
export const GMAX_DAILY_PARTICLES = 60
export const GMAX_STARTING_PARTICLES = 80
export const GMAX_RAID_COST = 20
export const GMAX_GUARANTEED_FRAGMENTS = 100
export const GMAX_PITY_REQUIRED = 12

export const GMAX_CATCH_OVERKILL_PER_RATIO = 0.08
export const GMAX_CATCH_PITY_PER_STACK = 0.015
